import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../../core/Icon";
import { SmartTable } from "../../../core/SmartTable";
import { Spinner } from "../../../core/Spinner";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig } from "../../../app-state";
import { getCategoryLabel } from "../../../enums/categoryOptions";
import moment from "moment";
import { getEventEditUrl } from "../../common/event/EventHelper";
import { phpBool } from "../../../core/Helpers";
export const List = () => {
    const [events, setEvents] = useState(null);
    const [loadState, setLoadState] = useState('firstLoad'); // firstLoad | loading | loaded
    const headings = [
        { title: "Ref.č.", attr: "refno" },
        { title: "Název aukce", attr: "title" },
        { title: "Kategorie", attr: "category", dictionary: getCategoryLabel },
        { title: "Začátek", attr: "start" },
        { title: "Publikováno", attr: "publish", className: "text-right" },
    ];
    const loadEvents = () => {
        AppLoad(AppConfig.APIUrl + 'admin/event-management/list', { hello: "kitty" }).then((Response) => {
            if (Response.status == 'error') {
                //setSubmitErrors(Response.errors)
            }
            else if (Response.status == 'ok') {
                setEvents(Response.data);
                setLoadState('loaded');
                // history.push('/cs/proces/registrace/dokonceno');
            }
        });
    };
    useEffect(loadEvents, []);
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "flex-space" },
            React.createElement("div", { className: "t1" },
                React.createElement("h1", { className: "page-title" }, "Spr\u00E1va aukc\u00ED")),
            React.createElement("div", { className: "t3" },
                React.createElement(Link, { to: "/cs/sekce/sprava-aukci/nova", className: "cta-plus" },
                    "Vytvo\u0159it aukci",
                    React.createElement(Icon, { c: ['plus-circle', 24, 24] })))),
        loadState == 'firstLoad' ?
            React.createElement(Spinner, { large: true })
            :
                React.createElement(SmartTable, { headings: headings, rows: events, row: (data) => {
                        return React.createElement("tr", null,
                            React.createElement("td", null, data.refno),
                            React.createElement("td", null,
                                React.createElement(Link, { className: "hyperlink", to: getEventEditUrl(data) }, data.title)),
                            React.createElement("td", null, getCategoryLabel(data.category)),
                            React.createElement("td", null, data.start ? moment.unix(data.start).format('D. M. YYYY, HH:mm') : 'Nestanoveno'),
                            React.createElement("td", { className: "text-right" }, phpBool(data.publish) ? 'Ano' : 'Ne'));
                    } })));
};
